import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@material-ui/core'

import Button from '@/components/button'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'
import { transformUnderscoreInSpaceAndUppercaseFirstLetter } from '@/utils/format-strings'

import { useStyles } from './styles'

export function SelectLayers() {
  const classes = useStyles()

  const {
    infestationData,
    toggleRemovedAllLayers,
    toggleRemovedLayer,
    nextStep,
    previousStep,
  } = useCreatePulverizationMap()

  return (
    <>
      <div className={classes.root}>
        <header>
          <Typography variant='h3'>Selecione as camadas para o mapa</Typography>
        </header>

        <FormGroup>
          <FormControlLabel
            onChange={(_, checked) => toggleRemovedAllLayers(!checked)}
            checked={infestationData?.layersMap.every(
              (layer) => !layer.removed,
            )}
            control={
              <Checkbox
                indeterminate={infestationData?.layersMap.some(
                  (layer) => layer.removed,
                )}
                size='small'
              />
            }
            label='Todas as camadas de daninhas'
          />
          {infestationData?.layersMap.map((layer, index) => (
            <FormControlLabel
              key={layer.name}
              name={layer.name}
              checked={!layer.removed}
              onChange={(_, checked) => toggleRemovedLayer(index, !checked)}
              control={<Checkbox size='small' />}
              label={
                <>
                  <span>
                    {transformUnderscoreInSpaceAndUppercaseFirstLetter(
                      layer.name,
                    )}
                  </span>
                  <span>{layer.area.ha.toFixed(2)} ha</span>
                </>
              }
            />
          ))}
        </FormGroup>
      </div>

      <div className={classes.buttonContainer}>
        <Button outlined onClick={previousStep}>
          Cancelar
        </Button>
        <Button
          onClick={nextStep}
          disabled={infestationData?.layersMap.every((layer) => layer.removed)}
        >
          Avançar
        </Button>
      </div>
    </>
  )
}
